<template lang="pug">
  .garbage.settlement-update
    e-form-modal(
      ref="modalForm"
      @submitModalForm="sendForm()"
      @deleteItem="deleteItem()"
      :hideDeleteButton="(!!fields.id)"
    )
      div(slot="header" style="flex-grow:1")
        e-breadcrumbs
        h1.modal__title(v-html="title")
        e-form-tabs(
          v-model="tabView"
          :tabs="tabs"
          customClass="tabs_no-border"
        )
      slot
        e-form(:formValidator="formValidator" formClass="modal__body")
          // ОБЩИЕ СВЕДЕНИЯ
          .body-flex(v-show="tabView === 'tab1'")
            input(type="hidden" v-model="fields.parent_id")
            .modal__row
              .modal__col
                e-form-subtitle(text="Реквизиты")

                e-form-group(
                  name="name"
                  inputType="input"
                  label="Наименование"
                  :model="fields"
                  :required="true"
                  tabView="tab1"
                )
                e-form-group(
                  name="area"
                  inputType="input"
                  label="Площадь"
                  :model="fields"
                  tabView="tab1"
                )
                e-form-group(
                  name="people_count"
                  inputType="input"
                  label="Население"
                  :model="fields"
                  tabView="tab1"
                )
                e-form-group(
                  name="status_id"
                  inputType="select"
                  :required="true"
                  label="Статус объекта"
                  :model="fields"
                  tabView="tab1"
                  :options="statuses"
                )
                e-form-group(
                  name="close_date"
                  inputType="calendar"
                  label="Дата закрытия"
                  :model="fields"
                  tabView="tab1"
                  type="date"
                  :disabled="fields.status_id !== notActive"
                )
                e-form-group(
                  v-show="hasGarbageCadastreField"
                  name="cadastr"
                  inputType="input"
                  label="Кадастровый номер"
                  :model="fields"
                  tabView="tab1"
                )
              .modal__col
                e-form-subtitle(text="Управление")
                e-form-group(
                  name="government"
                  inputType="input"
                  label="Орган управления"
                  :model="fields"
                  tabView="tab1"
                )
                e-form-group(
                  name="head_name"
                  inputType="input"
                  label="Контактное лицо"
                  :model="fields"
                  tabView="tab1"
                )
                e-form-group(
                  name="head_phone"
                  inputType="input"
                  validationRule="phone"
                  label="Телефон"
                  :model="fields"
                  tabView="tab1"
                )
                e-form-group(
                  name="head_email"
                  inputType="input"
                  validationRule="email"
                  label="Email"
                  :model="fields"
                  tabView="tab1"
                )

              .modal__col
                e-form-subtitle(text="Местоположение")

                e-location(
                  :formValidator="formValidator"
                  :model="fields"
                  name="fact_address"
                  :required="true"
                  :addressData="addressData"
                  addressIdFieldName="fact_address_id"
                  tabView="tab1"
                )
                e-form-group(
                  name="photoPreview"
                  inputType="simple-file-uploader"
                  label="Фотография"
                  :model="fields"
                  tabView="tab1"
                  :uploadUrl="uploadUrl"
                  @fileUploaded="fileUploaded"
                  @fileRemoved="fileRemoved"
                  :showFilePreview="true"
                )


            // ОБСЛУЖИВАЕМЫЕ ДОМА
          .body-flex(v-show="tabView === 'tab2'")
            house-table(
              :id="fields.id"
              ref="houseTable"
              tabView="tab2"
            )

          // ОТХОДЫ
          .body-flex(v-if="tabView === 'tab3'")
            garbage-table(:id="fields.id" ref="garbageTable" tabView="tab3")

          // ОПЕРАТОРЫ
          .body-flex(v-show="tabView === 'tab4'")
            operator-table(:id="fields.id" ref="operatorTable" tabView="tab4")

          // Маршруты
          .body-flex.routes(v-if="tabView === 'routes'")
            routes-table(:fields="fields" :id="fields.id" ref="routesTable" tabView="routes")

          // Журнал изменений
          .body-flex(v-show="tabView === 'tab5'")
            change-log-tab(
              :entityId="fields.id"
              :moduleId="moduleId"
            )

          // Документы
          .body-flex(v-show="tabView === 'tab6'")
            documents-table(
              :document-ids="documentIds"
              @documentsChanged="documentsChanged"
            )
</template>

<script>
import { core, garbage } from '@/api/api-endpoints'
import { GARBAGE_TYPE_SETTLEMENT } from '@/config/config'
import garbageForm from './mixins/garbage-form'
import HouseTable from './components/house-table'

export default {
  components: { HouseTable },
  mixins: [garbageForm],
  data() {
    return {
      tabView: 'tab1',
      fields: {
        status_id: '',
        business_category_id: '',
        latitude: '',
        longitude: '',
        garbage_source_type_id: GARBAGE_TYPE_SETTLEMENT,
        garbage_source_category_id: '',
      },
      errors: null,
    }
  },
  computed: {
    moduleId() {
      return this.moduleIds['garbage-source']
    },
    tabs() {
      const tabs = [
        { tab1: 'Общие сведения' },
        { tab2: 'Обслуживаемые дома' },
        { tab3: 'Отходы' },
        { tab4: 'Операторы' },
        { routes: 'Маршруты' },
      ]
      if (this.fields.id) {
        tabs.push({ tab5: 'Журнал изменений' })
      }
      tabs.push({ tab6: 'Документы' })
      return tabs
    },
  },
  methods: {
    update() {
      garbageForm.methods.update.call(this)
    },
    prepareFieldsForSend(fields = {}) {
      return fields
    },
    getBusinessCategoriesEndpoint() {
      return core.statuses({ fields: 'business_category' })
    },
    getStatusEndpoint() {
      return core.statuses({ fields: 'status' })
    },
    getDeleteUrl(id) {
      return garbage.garbageDelete(id)
    },
    getUpdateOrCreateUrl() {
      return garbage.garbageUpdateOrCreate(this.$route.params.id)
    },
    getItemEndpoint(route) {
      if (!route.params.id) {
        return null
      }
      return garbage.garbage(route.params.id)
    },
  },
}
</script>
